<template>
    <div class="high-diagram">
        <div class="bg-img-wrap">
            <div class="total-wrap" id="main" ref="main">
                <div
                    id="canvas"
                    ref="canvas"
                    class="canvas-wrap"
                    :style="
                        `transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`
                    "
                >
                    <img class="bg-img" src="../../../../assets/image/diagram/9-04.png" alt srcset />
                    <div
                        v-for="(item, index) in datas"
                        :key="item.point_id"
                        class="bian-switch"
                        :style="`top:${item.bian_top}%;left:${item.bian_left}%;`"
                    >
                        <template v-if="index != 0">
                            <template v-if="item.isOn == 1">
                                <img
                                    src="../../../../assets/image/diagram/b1.png"
                                    alt
                                    srcset
                                    class="kaiguan-1"
                                />
                            </template>
                            <template v-else-if="item.isOn == 0">
                                <img
                                    src="../../../../assets/image/diagram/b5.png"
                                    alt
                                    srcset
                                    class="kaiguan-1"
                                />
                            </template>
                            <template v-else>
                                <img
                                    src="../../../../assets/image/diagram/b3.png"
                                    alt
                                    srcset
                                    class="kaiguan-1"
                                />
                            </template>
                        </template>
                    </div>
                    <div
                        v-for="item in datas"
                        :key="item.point_id"
                        class="top-switch"
                        :style="`top:${item._top}%;left:${item._left}%;`"
                        v-show="item.showBian"
                    >
                        <template v-if="item.isOn == 1">
                            <img
                                src="../../../../assets/image/diagram/guan-new.png"
                                alt
                                srcset
                                class="kaiguan"
                            />
                        </template>
                        <template v-else>
                            <img
                                src="../../../../assets/image/diagram/kai-new.png"
                                alt
                                srcset
                                class="kaiguan"
                            />
                        </template>
                        <!-- <template v-else>
                            <img
                                src="../../../../assets/image/diagram/error.png"
                                alt
                                srcset
                                class="kaiguan"
                            />
                        </template>-->
                    </div>
                    <div
                        v-for="item in datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top};left:${item.left};`"
                        @click="showdialog(item)"
                        v-show="item.showBian"
                    >
                        <template>
                            <div class="data-item">
                                <div class="data-name yellow">电压</div>
                                <div class="data-number diagram-input-bg">
                                    {{ item.ia }}
                                    <span>kV</span>
                                </div>
                            </div>
                            <div class="data-item">
                                <div class="data-name yellow">总有功功率</div>
                                <div class="data-number diagram-input-bg">
                                    {{ item.ib }}
                                    <span>kW</span>
                                </div>
                            </div>
                            <div class="data-item">
                                <div class="data-name yellow">功率因数</div>
                                <div class="data-number diagram-input-bg">
                                    {{ item.ic }}
                                    <span></span>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <ElecDialog :dialogVisible.sync="dialogVisible" :id="data_id" />
    </div>
</template>
<script>
import * as api from "@/http/http-60.js";
import ElecDialog from "./elec-diagram-dialog.vue"
export default {
    components: {
        ElecDialog
    },
    data() {
        return {
            diagramType: 1,
            left: "0",
            top: "30",
            scale: 1,
            basisUnitV: 1,
            basisUnitH: 1,
            scaleIcon: 0.5,
            dialogVisible: false,
            data_id: "",
            dialogTitle: "",
            datas: [
                {
                    point_id: "1374970016642060290",
                    name: "10kv进线", //主线名称
                    // 开关
                    _top: 8.9,
                    _left: 50,
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "15%",
                    left: "55%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                    showBian: true
                },
                {
                    point_id: "1374971892548718592",
                    name: "4#主变进线", //主线名称
                    // 开关
                    _top: 30.5,
                    _left: 29.25,
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "40%",
                    left: "20%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                    bian_top: 51.5,
                    bian_left: 13.1,
                    showBian: true
                },
                {
                    point_id: "1374971892548718592",
                    name: "1#主变进线", //主线名称
                    // 开关
                    _top: 0,
                    _left: 0,
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "0%",
                    left: "0%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                    bian_top: 51.5,
                    bian_left: 29.5,
                    showBian: false
                },
                {
                    point_id: "1374971973049995264",
                    name: "2#主变进线", //主线名称
                    // 开关
                    _top: 45,
                    _left: 45.5,
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "0%",
                    left: "0%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                    bian_top: 51.5,
                    bian_left: 50.2,
                    showBian: false
                },
                {
                    point_id: "1374971973049995264",
                    name: "5#主变进线", //主线名称
                    // 开关
                    _top: 30.5,
                    _left: 50,
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "40%",
                    left: "55%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                    bian_top: 51.5,
                    bian_left: 65.5,
                    showBian: true
                },
                {
                    point_id: "1374971778635616256",
                    name: "3#主变进线", //主线名称
                    // 开关
                    _top: 30.5,
                    _left: 85.17,
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "40%",
                    left: "89%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                    bian_top: 51.5,
                    bian_left: 85.4,
                    showBian: true
                },
            ],
            timer: null,
        };
    },
    mounted() {
        this.zoom();
        this.drag();
        this.getData();
        this.setTimer();
        this.setImgSize();
        window.onresize = () => {
            this.setImgSize();
        };
    },
    methods: {
        setImgSize() {
            if (window.innerWidth >= 2560) {
                this.basisUnitH = 1.2;
                this.basisUnitV = 1.2;
            } else if (window.innerWidth < 2560 && window.innerWidth >= 1900) {
                this.basisUnitH = 1.0;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1920 && window.innerWidth >= 1660) {
                this.basisUnitH = 0.82;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1660 && window.innerWidth >= 1420) {
                this.basisUnitH = 0.7;
                this.basisUnitV = 0.7;
            } else if (window.innerWidth < 1420 && window.innerWidth >= 1320) {
                this.basisUnitH = 0.6;
                this.basisUnitV = 0.6;
            } else {
            }
        },
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.getData();
            }, 10000);
        },
        getData() {
            let pointIds = [];
            this.datas.forEach(item => {
                pointIds.push(item.point_id);
            });
            api.getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                this.datas.forEach(item => {
                    let point = valueJson[item.point_id];
                    // 电压（平均）
                    let tempV = 0;
                    if(item.point_id == '1374970016642060290') {
                        tempV = (parseFloat(point && point.v_a) + parseFloat(point && point.v_c)) / 2 / 1000;
                    } else {
                        tempV = (parseFloat(point && point.v_a) + parseFloat(point && point.v_b) + parseFloat(point && point.v_c)) / 3;
                    }
                    item.ia = tempV.toFixed(2);
                    // 总有功功率(求和)
                    let tempP = parseFloat(point && point.p_a) + parseFloat(point && point.p_b) + parseFloat(point && point.p_c);
                    item.ib = tempP.toFixed(2);
                    // 功率因数（平均）
                    let tempPf = (parseFloat(point && point.pf_a) + parseFloat(point && point.pf_b) + parseFloat(point && point.pf_c)) / 3;
                    item.ic = tempPf.toFixed(2);
                    // A相电压有数据时，isOn为1 否则为0
                    // if (point && point.is_offline) {
                    item.isOn = point.is_offline == 1 ? 0 : 1
                    // } else {
                    //     item.isOn = -1;
                    // }

                });
            });
        },
        showdialog(item) {
            this.dialogVisible = true;
            this.data_id = item.point_id;
        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function (event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function (event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function (en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function (en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function () {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        }
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss" scoped>
.high-diagram {
    width: 100%;
    height: 100%;
    color: #fff;
    padding: 0 2rem 0rem 2rem;
    padding-top: 0;
    box-sizing: border-box;
    position: relative;

    h2 {
        color: #fff;
        line-height: 1.8rem;
        text-indent: 2.5rem;
        font-size: 16px;
        float: left;
    }

    .bg-img-wrap {
        margin: 0 auto;
        text-align: center;
        align-self: center;
        width: 100%;
        height: 100%;
        position: relative;
        .kaiguan {
            width: 4.5rem;
            height: 9rem;
        }
        .kaiguan-1 {
            width: 4.5rem;
            height: 7.5rem;
        }
        .update-time {
            position: absolute;
            top: -1%;
            left: 11%;
            font-size: 0.8rem;
            color: #fff;
        }
        .total-wrap {
            top: 0%;
            left: 0%;
            width: 100%;
            padding: 2rem 2rem 0 2rem;
            box-sizing: border-box;
            height: 100%;
            position: relative;
            overflow: hidden;
            cursor: move;

            .canvas-wrap {
                width: 100%;
                // min-height: 100%;
                // height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                box-sizing: border-box;

                .bg-img {
                    width: 100%;
                    height: 100%;
                }
            }

            .bian-switch {
                // cursor: pointer;
                transform: scale(0.55);
                position: absolute;
                text-align: center;
                display: flex;
                // height: 20%;
                overflow: hidden;
            }
            .top-switch {
                // cursor: pointer;
                transform: scale(0.4);
                position: absolute;
                text-align: center;
                display: flex;
                // height: 20%;
                overflow: hidden;

                .top-title {
                    align-self: center;
                    margin-left: 0.7rem;
                    font-size: 0.8rem;
                }
            }

            .bottom-switch {
                // cursor: pointer;
                transform: scale(1);
                position: absolute;
                text-align: center;
                display: flex;
                height: 20%;
                overflow: hidden;

                .bottom-title {
                    align-self: center;
                    margin-left: 0.7rem;
                    font-size: 0.8rem;
                }
            }

            .data-wrap {
                position: absolute;
                display: grid;

                .data-item {
                    display: flex;
                    margin-bottom: 0.1rem;

                    .data-name {
                        align-self: center;
                        font-size: 0.8rem;
                        margin-right: 0.1rem;
                        width: 4rem;
                        text-align: right;
                        font-weight: bold;
                    }

                    .data-number {
                        font-size: 0.8rem;
                        width: 4.8rem;
                        text-align: right;
                        // background-color: #114aa5;
                        color: #fff;
                        height: 1.2rem;
                        line-height: 1.2rem;

                        nowrap span {
                            display: inline-block;
                            margin-left: 0.2rem;
                            margin-right: 0.2rem;
                        }
                    }

                    .data-u {
                        height: 1.1rem;
                        line-height: 1.1rem;
                    }

                    .data-name-u {
                        font-size: 0.9rem;
                        margin-right: 1rem;
                    }
                }
            }
        }
    }
    .red {
        color: #fe0101;
    }

    .yellow {
        color: #fefa00;
    }

    .green {
        color: #00b200;
    }
}
</style>
